<template>
  <div>
    <van-row :gutter="10">
      <van-col :span="24">
        <div :class="{'form-box-tag':true,'active':isactive}" @click="swap()">{{name}}</div>
      </van-col>
    </van-row>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="data" @confirm="confirm" @cancel="cancel" />
    </van-popup>
  </div>
</template>

<script>
import { Picker, Row, Col, Tag, Popup, NavBar } from "vant";

export default {
  components: {
    [Picker.name]: Picker,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar
  },

  data() {
    return {
      isactive: false,
      showPicker: false,
      data: [],
      name:'',
      community:{}
    };
  },
  props: {
    title: {
      type: String,
      default: "请选择"
    },
    lists: Object
  },
  mounted() {
    this.name = this.title;
  },

  methods: {
    swap(index, value) {
      this.showPicker = true;
      if (this.data.length < 1) {
        for (let i in this.lists) {
          this.data.push(this.lists[i]); //属性
        }
      }

    },
    confirm(value, index) {
      this.isactive = true;
      for (let i in this.lists) {
        if(this.lists[i]==value){
          this.community.id = i
          break;
        }
      }
      this.community.name = value;
      this.showPicker = false;
      this.name = value;
      this.$emit("change", this.community);
    },
    cancel(value, index) {
      this.showPicker = false;
    }
  }
};
</script>

<style scoped>
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
}
.form-box-tag.active {

    background-color: #fff;
  border:#f56229 1px solid;
  color: #f56229;
}
</style>>



